// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinnerContainer":"LoadingSpinner-module--loadingSpinnerContainer--1blBU"};